import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { parseFilters, toggleValue, updateSearch } from "./nflToolFilters";

export default function useUrlFilters(options) {
  const location = useLocation();
  const history = useHistory();

  const filters = useMemo(
    () => parseFilters(location.search, options),
    [location.search, options]
  );

  const update = useCallback(
    (patch) => {
      const search = updateSearch(location.search, patch);
      if (search === location.search) {
        return;
      }
      history.replace({ pathname: location.pathname, search });
    },
    [history, location.pathname, location.search]
  );

  return useMemo(
    () => ({
      ...filters,
      setSeason: (year) => update({ season: year }),
      togglePosition: (pos) =>
        update({ positions: toggleValue(filters.positions, pos) }),
      setWeeks: (weeks) => update({ weeks }),
      setTeams: (teams) => update({ teams }),
      toggleTeam: (abbrev, mode = "multi") => {
        if (mode === "single") {
          update({ teams: filters.teams[0] === abbrev ? [] : [abbrev] });
          return;
        }
        update({ teams: toggleValue(filters.teams, abbrev) });
      },
      clear: (key) =>
        update(
          key ? { [key]: null } : { positions: null, weeks: null, teams: null }
        ),
    }),
    [filters, update]
  );
}
